import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-entitlement-sale-single-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/single-select-search-control.component.html",
    providers: [
        registerSearchControl(EntitlementSaleSingleSelectSearchControlComponent)
    ]
})
export class EntitlementSaleSingleSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        this.buildData([
            {label: "wbo.bi.search.option.entitlement-sale.withoutEntitlement", value: 0},
            {label: "wbo.bi.search.option.entitlement-sale.withEntitlement", value: 1}
        ]);
    }
}
